import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { blogs } from '../utils/blogData';

export default function BlogPostPage() {
    const { slug } = useParams();
    const blog = blogs.find(b => b.slug === slug);

    useEffect(() => {
        if (blog) {
            document.title = `${blog.title} | PeerChargeEV`;
            
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.name = "description";
                document.head.appendChild(metaDescription);
            }
            metaDescription.setAttribute('content', blog.metaDescription);
            
            let metaKeywords = document.querySelector('meta[name="keywords"]');
            if (!metaKeywords) {
                metaKeywords = document.createElement('meta');
                metaKeywords.name = "keywords";
                document.head.appendChild(metaKeywords);
            }
            metaKeywords.setAttribute('content', `${blog.targetKeyword}, ${blog.secondaryKeywords}`);
        }
    }, [blog]);

    if (!blog) {
        return <Navigate to="/blog" replace />;
    }

    return (
        <div className="bg-white min-h-screen pt-24 pb-16">
            <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mb-8">
                    <Link to="/blog" className="text-green-600 hover:text-green-700 font-medium inline-flex items-center transition-colors">
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
                        Back to Blog
                    </Link>
                </div>
                
                <header className="mb-10 text-center">
                    <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 tracking-tight leading-tight mb-4">
                        {blog.title}
                    </h1>
                    <div className="flex items-center justify-center text-sm text-gray-500 mt-6 space-x-4">
                        <span className="flex items-center">
                            <svg className="w-5 h-5 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                            PeerChargeEV Team
                        </span>
                        <span>•</span>
                        <span>5 min read</span>
                    </div>
                </header>

                <div 
                    className="prose prose-lg prose-green mx-auto text-gray-600 leading-relaxed max-w-none"
                    dangerouslySetInnerHTML={{ __html: blog.content }}
                />
                
                <div className="mt-16 bg-green-50 rounded-2xl p-8 text-center border border-green-100">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to start with PeerChargeEV?</h3>
                    <p className="text-gray-600 mb-6">Join thousands of EV owners finding and sharing chargers across India.</p>
                    <a href="https://play.google.com/store/apps/details?id=com.niloy.peerchargerev" target="_blank" rel="noopener noreferrer" className="inline-block bg-green-600 text-white font-bold py-3 px-8 rounded-full hover:bg-green-700 transition-colors shadow-md hover:shadow-lg">
                        Download the App
                    </a>
                </div>
            </article>
        </div>
    );
}
